import { F01_IMAGES } from 'data/images/f01/default'
import {
  isBigResultsPitchCarouselVariant,
  isBigResultsPitchMockupVariant,
  isGoalPitchMockupVariant,
} from 'data/images/utils'
import type { ImagesDefinition } from 'types/images'

export const WALLPIF01_IMAGES = {
  ...F01_IMAGES,
  experience: {
    background: {
      width: 402,
      height: 540,
      srcSet: [
        '/images/wallpif01/memoji/experience.webp',
        '/images/wallpif01/memoji/experience@2x.webp',
      ],
    },
  },
  experiencePitch: {
    pitch: {
      width: 370,
      height: 233,
      srcSet: [
        '/images/wallpif01/memoji/experience_pitch.webp',
        '/images/wallpif01/memoji/experience_pitch@2x.webp',
      ],
    },
  },
  bigResultsPitch: {
    first: {
      width: 272,
      height: 320,
      srcSet: [
        '/images/wallpif01/memoji/big-results-pitch/big_results_pitch_01.webp',
        '/images/wallpif01/memoji/big-results-pitch/big_results_pitch_01@2x.webp',
      ],
      prefetchCondition: isBigResultsPitchCarouselVariant,
    },
    second: {
      width: 272,
      height: 320,
      srcSet: [
        '/images/wallpif01/memoji/big-results-pitch/big_results_pitch_02.webp',
        '/images/wallpif01/memoji/big-results-pitch/big_results_pitch_02@2x.webp',
      ],
      prefetchCondition: isBigResultsPitchCarouselVariant,
    },
    third: {
      width: 272,
      height: 320,
      srcSet: [
        '/images/wallpif01/memoji/big-results-pitch/big_results_pitch_03.webp',
        '/images/wallpif01/memoji/big-results-pitch/big_results_pitch_03@2x.webp',
      ],
      prefetchCondition: isBigResultsPitchCarouselVariant,
    },
    mockup: {
      width: 370,
      height: 300,
      srcSet: [
        '/images/wallpif01/memoji/big-results-pitch/big_results_pitch_mockup_{{locale}}.webp',
        '/images/wallpif01/memoji/big-results-pitch/big_results_pitch_mockup_{{locale}}@2x.webp',
      ],
      prefetchCondition: isBigResultsPitchMockupVariant,
    },
  },
  problemAreasPitch: {
    mockup: {
      width: 370,
      height: 300,
      srcSet: [
        '/images/wallpif01/memoji/problem-areas-pitch/problem_areas_pitch_mockup_wallpilates_{{locale}}.webp',
        '/images/wallpif01/memoji/problem-areas-pitch/problem_areas_pitch_mockup_wallpilates_{{locale}}@2x.webp',
      ],
    },
  },
  goalPitch: {
    mockup: {
      width: 370,
      height: 300,
      srcSet: [
        '/images/wallpif01/memoji/goal-pitch/goal_pitch_mockup_{{locale}}.webp',
        '/images/wallpif01/memoji/goal-pitch/goal_pitch_mockup_{{locale}}@2x.webp',
      ],
      prefetchCondition: isGoalPitchMockupVariant,
    },
  },
} satisfies ImagesDefinition
